<template>
  <div id="archive">
    <div v-if="isDesktop && selectedMode != 'reserve'" class="archive-pay-methods">
      <div v-for="payMethod in payMethods" :key="payMethod" class="pay-method-tab">{{ $t(`archive.tabs.${payMethod}`) }}</div>
    </div>
    <Navbar v-if="!isDesktop" @desktopNavigate="navigateBackToMode" />
    <NavbarDesktop
      @desktopNavigate="onSelectMode"
      :availableDates="availableDates"
      @onDateSelect="setHumanlySelectedDate"
      :viewingSummary="viewingSummary"
      @toggleSummaryView="toggleSummaryView"
      :currentMode="selectedMode"
      v-else
    />
    <div class="archive-container" v-if="!isDesktop">
      <span class="type" @click="changePayMethod" v-if="selectedMode != 'reserve'">{{ payMethodString }}</span>
      <span @click="showCalendar = true" class="date">
        <select class="date-select" v-model="humanlySelectedDate">
          <option v-for="date in availableDates" :value="date" :key="date">
            {{ date }}
          </option>
        </select>
      </span>

      <img
        :src="viewingSummary ? '/icons/card-view.png' : '/icons/list-view.svg'"
        class="view-changer"
        @click="toggleSummaryView"
        v-if="selectedMode != 'reserve'"
      />
    </div>
    <div class="archive-loader" v-if="loading">
      <h3>
        <font-awesome-icon icon="spinner" spin />
      </h3>
    </div>
    <div v-if="!isDesktop" class="blur-box">
      <ModeSwitcher
        v-if="!loading && !isDesktop"
        class="archive-mode-switcher"
        :current="selectedMode"
        :counters="counters"
        :cafe="cafe"
        @switch="onSelectMode"
      />
    </div>
    <div class="archive-content" v-if="!loading">
      <div class="archive-list" v-if="!viewingSummary && !isDesktop">
        <div class="inside-list" v-if="selectedMode == 'inside'">
          <div class="inside-list-item" v-for="order in filteredOrders" :key="order._id">
            <QueueItem class="archive-item" :cafe="cafe" :order="order" readonly />
          </div>
        </div>
        <div class="reserve-list" v-else-if="selectedMode == 'reserve'">
          <div v-for="reservation in reservations" :key="reservation._id"> 
            <ReservationCard :reservation="reservation"/>
          </div>
        </div>
         <div class="hotels-list" v-else-if="selectedMode == 'hotels'">
          <div class="archive-item" v-for="room_order in room_orders" :key="room_order._id"> 
            <RoomOrderCard :room_order="room_order"/>
          </div>
        </div>
        <!-- TAEKEAWAY + DELIVERY -->
        <div class="preorder-list" v-else>
          <div class="preorder-list-item" v-for="order in filteredOrders" :key="order._id">
            <DeliveryCard class="archive-item" :preorder="order" v-if="order.is_delivery" />
            <PreorderCard class="archive-item" :preorder="order" v-else />
          </div>
        </div>

        <div v-if="filteredOrders.length == 0 && reservations.length == 0">
          <p class="no-orders" show>{{ $t("archive.no_checks") }}</p>
        </div>
      </div>

      <div class="archive-summary" v-if="viewingSummary && !isDesktop">
        <div class="list-item" v-for="(item, index) in summary.rows" :key="index">
          <span class="name">{{ item.name }}</span>
          <span class="amount">{{ item.quantity }}х</span>
          <span class="price">{{ item.price }}{{ currency.symbol }}</span>
        </div>
      </div>
      <div v-if="viewingSummary && !isDesktop" class="summary-box">
        <div class="total-info">
          <span>{{ $t("archive.summary.total") }}</span>
          <span class="price">{{ summary.total }}{{ currency.symbol }}</span>
        </div>
        <div class="discount">
          <span>{{ $t("archive.summary.discount") }}</span>
          <span style="color:black">{{ summary.discount }}{{ currency.symbol }}</span>
        </div>
        <div class="tips">
          <span>{{ $t("archive.summary.tips") }}</span>
          <span style="color:black">{{ summary.tips }}{{ currency.symbol }}</span>
        </div>
      </div>

      <div v-if="viewingSummary && isDesktop" class="archive-list-summary-desktop">
        <div class="inside-archive-list-container">
          <div v-for="payMethod in payMethods" :key="payMethod" class="archive-cards-container">
            <div class="desktop-sumary-container">
              <div class="list-item" v-for="(item, index) in summary[payMethod].rows" :key="index">
                <span class="name">{{ item.name }}</span>
                <span class="amount">{{ item.quantity }}х</span>
                <span class="price">{{ item.price }}{{ currency.symbol }}</span>
              </div>

              <div
                v-if="
                  viewingSummary && isDesktop && summary[payMethod].rows.length
                "
                class="summary-box"
              >
                <div class="total-info">
                  <span>{{ $t("archive.summary.total") }}</span>
                  <span class="price">{{ summary[payMethod].total }}{{ currency.symbol }}</span>
                </div>
                <div class="discount">
                  <span>{{ $t("archive.summary.discount") }}</span>
                  <span style="color:black">
                    {{ summary[payMethod].discount
                    }}{{ currency.symbol }}
                  </span>
                </div>
                <div class="tips">
                  <span>{{ $t("archive.summary.tips") }}</span>
                  <span style="color:black">{{ summary[payMethod].tips }}{{ currency.symbol }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!viewingSummary && isDesktop" class="archive-list-desktop">
        <div class="inside-archive-list-container">
          <div
            v-for="(payMethod, index) in payMethods"
            :key="index"
            class="archive-cards-container"
          >
            <div class="inside-list-item" v-for="order in filteredOrders[index]" :key="order._id">
              <QueueItem v-if="selectedMode == 'inside'" :cafe="cafe" :order="order" readonly />
              <PreorderCard v-else-if="selectedMode == 'preorder'" :preorder="order" />
              <DeliveryCard v-else-if="selectedMode == 'delivery'" :preorder="order" />
            </div>
            <div v-if="index == 1 && selectedMode == 'reserve'">
              <div class="inside-list-item" v-for="reservation in reservations" :key="reservation._id">
                <ReservationCard :reservation="reservation"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QueueAPI from "@/api/queue";
import moment from "moment";
import Navbar from "@/components/Navbar.vue";
import NavbarDesktop from "@/components/NavbarDesktop.vue";
import ModeSwitcher from "@/components/ModeSwitcher.vue";
import QueueItem from "@/components/QueueItem.vue";
import PreorderCard from "@/components/preorder/PreorderCard.vue";
import DeliveryCard from "@/components/delivery/DeliveryCard.vue";
import ArchiveStatusTabs from "@/components/ArchiveStatusTabs.vue";
import ReservationCard from "@/components/notifications/ReservationCard.vue"
import RoomOrderCard from "@/components/hotels/RoomOrderCard.vue"

export default {
  data() {
    return {
      archiveQuery: {
        start: null,
        end: null,
      },

      list: [],
      preorders: [],
      summary: {},
      reservations: [],
      room_orders: [],
      counts: {},
      loading: true,
      viewingSummary: false,

      humanlySelectedDate: false,

      mode: "list",
      selectedMode: "inside",
      selectedPayMethod: "cash",
      payMethods: ["online", "card", "cash"],
    };
  },
  watch: {
    selectedMode() {
      if (this.isDesktop) {
        this.fetchOrdersForDesktop();
      } else this.fetchOrders();
    },
    selectedPayMethod() {
      this.fetchOrders();
    },
    humanlySelectedDate() {
      const ts = moment(this.humanlySelectedDate, "DD.MM.YYYY");

      this.archiveQuery.start = ts.startOf("day").valueOf();
      this.archiveQuery.end = ts.endOf("day").valueOf();
      if (this.isDesktop) {
        this.fetchOrdersForDesktop();
      } else this.fetchOrders();
    },
  },
  methods: {
    setHumanlySelectedDate(date) {
      this.humanlySelectedDate = date;
    },

    switchMode() {
      if (this.mode === "list") {
        this.mode = "summary";
        this.buildSummary();
      } else {
        this.mode = "list";
      }
    },
    navigateBackToMode(mode) {
      this.$router.push({
        name: "orders",
        query: {
          m: mode,
        },
      });
    },
    changePayMethod() {
      if (this.selectedPayMethod == "cash") {
        this.selectedPayMethod = "card";
      } else if (this.selectedPayMethod == "card") {
        this.selectedPayMethod = "online";
      } else {
        this.selectedPayMethod = "cash";
      }
    },
    fetchOrders() {
      const start = moment(this.archiveQuery.start).valueOf();
      const end = moment(this.archiveQuery.end).valueOf();

      QueueAPI.queryArchive(
        start,
        end,
        this.selectedMode,
        this.selectedPayMethod
      )
        .then((data) => {
          this.list = data.list;
          this.preorders = data.preorders;
          this.reservations = data.reservations;
          this.room_orders = data.room_orders;
          this.summary = data.summary;
          this.loading = false;
          this.counts = data.counts;
        })
        .catch((error) => {
          alert(error);
        });
    },
    fetchOrdersForDesktop() {
      this.list = [];
      this.preorders = [];
      const start = moment(this.archiveQuery.start).valueOf();
      const end = moment(this.archiveQuery.end).valueOf();
      this.payMethods.forEach((payMethod) => {
        QueueAPI.queryArchive(start, end, this.selectedMode, payMethod)
          .then((data) => {
            this.list.push(data.list);
            this.preorders.push(data.preorders);
            this.reservations = data.reservations;
            this.summary[payMethod] = data.summary;
            this.room_orders = data.room_orders;
            this.loading = false;
            this.counts = data.counts;
          })
          .catch((error) => {
            alert(error);
          });
      });
    },
    onDateSelect(newDate) {
      if (
        this.archiveQuery.start === newDate.start &&
        this.archiveQuery.end === newDate.end
      ) {
        return;
      }

      this.archiveQuery = newDate;
      this.showCalendar = false;

      if (this.isDesktop) {
        this.fetchOrdersForDesktop();
      } else this.fetchOrders();
    },
    backToQueue() {
      this.$router.push("/orders");
    },
    onSelectMode(mode) {
      this.selectedMode = mode;
    },
    toggleSummaryView() {
      this.viewingSummary = !this.viewingSummary;
    },
    checkModes() {
      if (this.cafe.modes.inside) {
        this.onSelectMode('inside');
      } else if (this.cafe.modes.preorder) {
        this.onSelectMode('preorder');  
      } else if (this.cafe.modes.delivery) {
        this.onSelectMode('delivery');  
      }
    }
  },
  computed: {
    isDesktop() {
      return window.innerWidth > 768;
    },
    availableDates() {
      const dates = [];

      let ptr = moment().subtract(30, "days");
      const end = moment().endOf("day");

      while (ptr.isBefore(end)) {
        dates.push(ptr.format("DD.MM.YYYY"));
        ptr = ptr.add(1, "day");
      }

      return dates;
    },
    filteredOrders() {
      if (this.selectedMode == "inside") {
        return this.list;
      } else {
        return this.preorders;
      }
    },

    queryDateString() {
      return moment(this.archiveQuery.start).format("DD.MM.YYYY");
    },
    cafe() {
      return this.$store.state.cafe;
    },
    counters() {
      return this.counts;
    },
    payMethodString() {
      return this.$t(`archive.tabs.${this.selectedPayMethod}`);
    },
    currency() {
      return this.$store.state.currency;
    },
  },
  mounted() {
    this.$store.dispatch('init').then(ok => {
      this.checkModes();
    });
    this.humanlySelectedDate = moment().format("DD.MM.YYYY");
  },
  components: {
    QueueItem,
    Navbar,
    NavbarDesktop,
    ModeSwitcher,
    ArchiveStatusTabs,
    PreorderCard,
    DeliveryCard,
    ReservationCard,
    RoomOrderCard
  },
};
</script>

<style scoped>
.archive-container {
  background: black;
  width: 100%;
  display: flex;
  justify-content: space-between;
  position: fixed;
  bottom: 0;
  padding: 1.3vh 2.5vh 3.7vh;
  color: white;
  z-index: 5;
}

.inside-list-item {
  width: 100%;
}

.inside-list {
  padding-bottom: 15vh;
}

.archive-summary {
  width: 85%;
  padding-top: 3vh;

  margin: 0 auto;
}

.summary-box {
  width: 90%;
  margin: 0 auto;
}

.total-info span:first-child {
  font-size: 3vh;
  line-height: normal;
  color: #1d1d1d;
  font-weight: 500;
}

.list-item span.price {
  color: #a4a3a1;
}

.calendar {
  display: block;
  text-align: right !important;
  padding-left: 20px;
  margin: 10px auto;
  width: 180px;
  margin-bottom: 0;
}

.total-info,
.discount,
.tips {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  padding: 1.2vh 0 0;
}

.total-info {
  padding: 2vh 5vw;
}

.discount,
.tips {
  color: #a4a3a1;
  font-weight: 500;
  font-size: 2.5vh;
}

.price {
  font-size: 32px;
  color: #303030;
  line-height: normal;
  font-weight: 500;
}

.list-item {
  display: flex;
  padding: 1vh;
  line-height: normal;
  justify-content: space-between;
  border-top: 1px solid #1d1d1d;
  border-bottom: 1px solid #1d1d1d;
}

.list-item span {
  color: black;
  font-size: 3vh;
  font-weight: 500;
}

.type,
.date {
  border-radius: 5vh;
  padding: 1vh;
  min-width: 40%;
  text-align: center;
  align-self: center;
  color: #a4a3a1;
  border: 2px solid #a4a3a1;
  font-size: 2.5vh;
  line-height: normal;
}

img.view-changer {
  height: 5.5vh;
  width: auto;
}

.switcher {
  display: inline-block;
  border: 1px solid white;
  padding: 9px 0;

  margin-top: 5px;
  z-index: 3;
  border-radius: 25px;
  text-align: center;
}

.archive-loader {
  text-align: center;
}

.blur-box {
  background: transparent;
  width: 100%;
  height: 17vh;
  -webkit-backdrop-filter: blur(3px);
  backdrop-filter: blur(3px);
  position: fixed;
  z-index: 2;
}

.archive-content {
  padding-top: 15vh;
}

.switcher span {
  padding: 11px 25px 11px 20px;
}

.switcher span.active-l {
  background: white;
  color: black;
  border-radius: 25px 0 0 25px;
}

.switcher span.active-r {
  border-radius: 0px 25px 25px 0px;
  background: white;

  color: black;
}

.switcher span:first-child {
  border-right: 1px solid white;
}

.archive-total {
  text-align: center;
  font-size: 18pt;
}

.total {
  color: #10bd74;
}

.archive-item {
  margin: 0 auto;
  margin-bottom: 20px;
  width: 90%;
}

.archive-item:first-child {
  margin-top: 2.5vh !important;
}

.archive-status-tabs-container {
  display: block;
  top: 70px;
  z-index: 1;
  width: 100%;
  margin: 0 auto;
  text-align: center;
}

.no-orders {
  width: 90%;
  margin: 2vh auto 0;
  text-align: center;
}

.date-select {
  color: #a4a3a1;
  -webkit-appearance: none;
  outline: none;
  border: none;
  background: transparent;
  text-align: center;
  text-align-last: center;
}

.inside-archive-list-container {
  display: flex;
}

.reserve-list {
  margin-top: 3vh;
}

.preorder-list {
  margin-bottom: 15vh;
}

.hotels-list {
  margin-bottom: 10vh;
}

@media screen and (min-width: 768px) {
  #archive {
    overflow: hidden;
  }
  .inside-list-item {
    width: 80%;
  }
  div.archive-content {
    padding: 0;
    overflow: hidden;
    height: 100vh;
  }
  .date-select option {
    height: 10px;
  }

  div.inside-archive-list-container {
    overflow: hidden;
  }
  .archive-list-desktop {
    overflow: hidden;
  }
  .archive-cards-container {
    width: 33%;
    border-right: 0.069vw solid #c4c4c4;
    height: 100vh;
    overflow: auto;
    padding: 12vw 0 5.5vw;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .archive-cards-container::-webkit-scrollbar {
    width: 0 !important;
  }
  .archive-cards-container:nth-child(3n) {
    border: none;
  }
  .archive-pay-methods {
    position: fixed;
    bottom: 0;
    left: 0;
    padding: 0 2.604vw;
    width: 100%;
    height: 5.694vw;
    z-index: 10;
    background: rgba(29, 29, 27, 0.9);
    backdrop-filter: blur(7px);
    display: flex;

    align-items: center;
    justify-content: space-around;
  }
  .pay-method-tab {
    font-weight: 500;
    font-size: 1.528vw;
    line-height: 1.736vw;
    color: #ededed;
    border: 0.139vw solid #ededed;
    box-sizing: border-box;
    border-radius: 2.083vw;
    padding: 0.556vw 1.944vw;
  }
  .desktop-sumary-container {
    width: 22.569vw;
    padding: 0 0 1.389vw;
    margin-top: 1.389vw;
  }
  .summary-box {
    margin: 0;
    width: 22.569vw;
    border-top: 0.069vw solid #1d1d1b;
  }
  .list-item {
    margin: 0;
    margin: 0;
    border-bottom: none;
    border-top: 0.069vw solid #1d1d1b;
  }
  .list-item span.name {
    font-size: 1.25vw;
    line-height: 1.944vw;
    width: 13.264vw;
  }
  .list-item span.amount,
  .list-item span.price {
    font-size: 1.667vw;
    line-height: 1.944vw;
    margin-left: 0.694vw;
    min-width: 0;
  }
  .total-info {
    padding: 1.389vw;
    display: flex;
    justify-content: space-between;
  }
  div.total-info span {
    font-size: 1.667vw;
    line-height: 1.944vw;
  }
  div.total-info span.price {
    font-size: 2.5vw;
    line-height: 2.847vw;
  }
  div.discount span,
  div.tips span {
    font-size: 1.389vw;
    line-height: 1.597vw;
  }
  div.discount span:nth-child(2n),
  div.tips span:nth-child(2n) {
    font-size: 1.667vw;
    line-height: 1.944vw;
  }
}
</style>
